import React from 'react';
import { connect } from 'react-redux';

import ProfileSidebar from '../../Components/Profile/ProfileSidebar';

const ProjectLeftSide = ({ profile }) => (
  <ProfileSidebar
    profile={profile}
    editPath="/profile"
    showRating
    details={[
      { label: 'E-mail', value: profile.email },
      { label: 'Téléphone', value: profile.phone_number },
      { label: 'Adresse', value: profile.address },
    ]}
  />
);

const mapStateToProps = ({ firebase }) => ({ profile: firebase.profile || {} });
export default connect(mapStateToProps)(ProjectLeftSide);
